import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box } from '@components/Box';
import { SpacingStack } from '@components/SpacingStack';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import {
  OffsetTopColumnImage,
  PlusoneFeatureText,
  OffsetTopColumn,
  PlusoneFeatureImageWrap,
  PlusoneFeatureWrap,
  PlusOneAttendeeContent,
  PlusoneFeatureColumns,
} from './PlusOnes.styles';
import { PlusOneAttendee } from './PlusOneAttendee';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { useTranslation } from 'react-i18next';

export const PlusOnes: React.FC<{}> = () => {
  const { t } = useTranslation('onlineRsvp');
  const plusOnesData = t('plusOnes');
  const isMobileDevice = useThemeMediaQuery('below_sm');
  const sectionId = 'Groups_and_Plus_One_Controls';
  return (
    <Box id={sectionId}>
      <PlusOneAttendee />
      <PlusOneAttendeeContent backgroundColor="yellow1" paddingTop={[7]} paddingBottom={[12]}>
        <Columns>
          <Columns.Column offset="two" width="eight">
            <SpacingStack spacing={[12]}>
              <TextPairing
                alignment="center"
                eyebrow={plusOnesData.eyebrow}
                eyebrowColor="blue5"
                eyebrowVariant="sectionEyeBrow24"
                eyebrowTagName="h2"
                title={plusOnesData.title}
                titleColor="blue6"
                titleVariant="hed96Break"
                titleTagName="h2"
                body={plusOnesData.content}
                bodyVariant="dek24"
                bodyMaxWidth="524px"
                bodyColor="blue6"
              />
            </SpacingStack>
          </Columns.Column>
        </Columns>
      </PlusOneAttendeeContent>

      <PlusoneFeatureWrap backgroundColor="yellow1">
        <PlusoneFeatureColumns>
          <OffsetTopColumn width="half">
            <Box marginTop={[5, 8, 14]}>
              <PlusoneFeatureText
                alignment={isMobileDevice ? 'center' : 'left'}
                title={ReactHtmlParser(plusOnesData.columns[0].title)}
                titleColor="blue6"
                titleVariant="calloutHed32"
                titleTagName="h3"
                body={plusOnesData.columns[0].content}
                bodyVariant="dek20"
                bodyMaxWidth="370px"
                bodyColor="blue6"
              />
            </Box>
          </OffsetTopColumn>
          <OffsetTopColumnImage width="half">
            <PlusoneFeatureImageWrap>
              <CloudImage alt={plusOnesData.imageAltTextUpper} width="100%" src={plusOnesData.image} />
            </PlusoneFeatureImageWrap>
          </OffsetTopColumnImage>
        </PlusoneFeatureColumns>
      </PlusoneFeatureWrap>
    </Box>
  );
};
